import React from 'react';
import Chip from '@material-ui/core/Chip';
import { useTranslation } from 'react-i18next';

const colorMapping = {
    PENDING: 'yellow',
    APPROVE: 'green',
    DECLINE: 'red',
    PRE_MODIFIED: 'yellow',
    POST_MODIFIED: 'yellow',
    COMPLETED: 'green',
    PAUSED: 'yellow',
    EMI_STOPED: 'yellow',
    DRAFTED: 'yellow'
};

export default function StateBadge(props) {
    const { t } = useTranslation();
    return (
        <Chip
            color="primary"
            label={t(`loan_states.${props.state}`)}
            size="small"
            style={{ backgroundColor: colorMapping[props.state] || 'yellow', color: 'black' }}
        />
    );
}
